<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...$$props}>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M4 14V2h2v12zM10 14V2h2v12z"
    clip-rule="evenodd"
  />
</svg>
